module.exports = __webpack_public_path__ + "static/media/undraw_online_articles_re_yrkj.7b3315c8.svg";